import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import HomeScreen from '../components/26ua-lm-lfc-b/home-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';
import WelcomeAgeVerificationScreen from '../components/ua-brand/welcome-age-verification-screen';
import FaceCaptureScreen from '../components/ua-brand/face-capture-screen';
import YoungAgeScreen from '../components/ua-brand/young-age-screen';
import WelcomeFormScreen from '../components/ua-brand/welcome-form-screen';
import FormScreen from '../components/ua-brand/form-screen';
import OtpScreen from '../components/ua-brand/otp-screen';
import AlreadyRegistered from '../components/promoter/already-registered';
import SuccessRegistered from '../components/promoter/success-registered';
import AuthorityScreen from '../common/authority-screen';
import ReviewFlowScreen from '../components/26ua-prl-s/review-flow-screen';
import BrandLineScreen from '../common/brand-line-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import PageFlowWrapper from '../common/lfc-registration-flow-wrapper';
import useScreenHistory from '../hooks/useScreenHistory';

const utm_campaign = sessionStorage.getItem('utm_campaign');

const LMLFCB26 = ({ isCharacteristicPage = false, handleToBrandLinePage }) => {
  const [formData, setFormData] = useState({});
  const historyEnabled = !isCharacteristicPage;
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 8.1,
      initialState: { brandLine: 'lm' },
      enabled: historyEnabled
    });
  const brandLine = historyState.brandLine || 'lm';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const telegramLink = `https://t.me/pmu_support_bot?start=ScnPck-${utm_campaign}`;

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('26UA-LM-LFC-B-100');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 5: {
        return (
          <WelcomeAgeVerificationScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1, true)}
            handleNextVerificationScreen={() => setScreenNumber(6)}
          />
        );
      }
      case 6: {
        return (
          <FaceCaptureScreen
            setScreenNumber={setScreenNumber}
            onSuccessFlow={() => setScreenNumber(8.1)}
          />
        );
      }
      case 7: {
        return (
          <YoungAgeScreen backButtonClick={() => setScreenNumber(6, true)} />
        );
      }
      case 8.1: {
        return (
          <HomeScreen
            onReviewClick={() => setScreenNumber(13)}
            onAllBrandsClick={() =>
              isCharacteristicPage
                ? handleToBrandLinePage()
                : setScreenNumber(15)
            }
            onAuthorityClick={() => setScreenNumber(16)}
          />
        );
      }
      case 8: {
        return (
          <WelcomeFormScreen
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => {
              sendEvent('registration');
              setScreenNumber(9);
            }}
            isHideSkipButton
            telegramLink={telegramLink}
          />
        );
      }
      case 9: {
        return (
          <FormScreen
            utm_campaign={utm_campaign}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(8, true)}
            telegramLink={telegramLink}
            setFormData={(data) => setFormData(data)}
            formData={formData}
            isPromoter
          />
        );
      }
      case 10: {
        return (
          <OtpScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            handleChangePhoneNumber={() => setScreenNumber(9, true)}
            successSendOtp={() => {
              sendEvent('passed_authorization');
              setScreenNumber(12);
            }}
            attemptsExhaustedChangeScreen={() => setScreenNumber(15)}
          />
        );
      }
      case 11: {
        return <AlreadyRegistered telegramLink={telegramLink} />;
      }
      case 12: {
        return <SuccessRegistered telegramLink={telegramLink} />;
      }
      case 13:
        return (
          <ReviewFlowScreen
            setScreenNumber={setScreenNumber}
            backToMenuButtonClick={() => setScreenNumber(8.1, true)}
            innerScreenNumber={
              historyEnabled ? historyState.innerScreenNumber : null
            }
            setInnerScreenNumber={
              historyEnabled
                ? (val) =>
                    setScreenNumber(13, false, { innerScreenNumber: val })
                : null
            }
          />
        );
      case 14: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(15, true)}
            nextButtonClick={() => setScreenNumber(8.1)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 15: {
        return (
          <AllBrandsScreen
            setScreenNumber={setScreenNumber}
            setBrandLine={(brand) => {
              setScreenNumber(14, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(8.1, true)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 16: {
        return (
          <AuthorityScreen
            setScreenNumber={cb}
            handleBackToMenu={() => setScreenNumber(8.1, true)}
            setReviewScreenNumber={() => setScreenNumber(13)}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };
  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {isCharacteristicPage ? (
        getScreen(screenNumber, setScreenNumber)
      ) : (
        <PageFlowWrapper handleSkipRegistration={() => setScreenNumber(8.1)}>
          {getScreen(screenNumber, setScreenNumber)}
        </PageFlowWrapper>
      )}
    </ScreensContext.Provider>
  );
};

export default LMLFCB26;
